/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ExamItemApproveViewModel } from "../types/ExamItemApproveViewModel.ts";

export const examItemApproveViewModelSchema = z.object({
  id: z.optional(
    z.number().int().describe("ID da questão a ser aprovada ou rejeitada."),
  ),
  isApprover: z.optional(
    z
      .boolean()
      .describe(
        "Indica se o usuário autenticado possui permissão de aprovador para esta questão.",
      ),
  ),
  label: z
    .string()
    .describe("Enunciado da questão (pode conter HTML). Opcional.")
    .nullish(),
  status: z
    .number()
    .int()
    .describe(
      "Status de aprovação a ser definido para a questão. Obrigatório. Enum EExamItemStatus: `1` = Pending, `2` = Approved, `3` = Rejected.",
    ),
  statusJustification: z
    .string()
    .min(0)
    .max(250)
    .describe(
      "Justificativa para a aprovação ou rejeição da questão. Obrigatório. Máximo 250 caracteres.",
    ),
  examItemCompanyId: z
    .number()
    .int()
    .describe("ID do vínculo da questão com a empresa. Opcional.")
    .nullish(),
}) as unknown as ToZod<ExamItemApproveViewModel>;
